import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { gapY } from '../Utils/gap'
import { Button } from '../Common/V2'

export const BiometricsStyled = styled.div({
  padding: '4rem 3.5rem',
})

export const BiometricsCallToActionStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '42rem',
  alignItems: 'center',
  justifyContent: 'center',

  '& > h1': {
    fontSize: '2.6rem',
    lineHeight: '2.8rem',
    textAlign: 'center',
    color: hexColors.blueDiamond,
  },

  '& > p': {
    color: hexColors.nightRider,
    fontSize: '1.6rem',
    textAlign: 'center',
  },
})

export const BiometricsIconContainerStyled = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4rem',
  backgroundColor: theme.colors.studio['100'],
  width: '14rem',
  height: '14rem',
}))

export const BiometricsFooterStyled = styled.footer(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  gapY('2.3rem')
)

export const BiometricsNeedHelpButtonStyled = styled(Button)({
  fontSize: '2.2rem',
  fontWeight: '700',
  lineHeight: '157%',
})

export const BiometricsCloseButtonStyled = styled.button({
  border: 0,
  background: 'none',
})
